module.exports = __webpack_public_path__ + "static/media/DoctorStrange.e17e8785.png";